import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot } from '@angular/router';
import { Store } from '@ngxs/store';
// Actions
import {
	SetProductListByIntegration,
	SetDeliveryAssetsAcuityDocumentTypes,
	SetDeliveryAssetsAppScopeDocumentTypes,
	SetDeliveryAssetsClassValuationDocumentTypes,
	SetDeliveryAssetsCmpAcuityDocumentTypes
} from '../../state/actions/global-configuration.actions';
import { SetHandleMode, SetTrackingSystems } from '../../state/actions/global-configuration-enums.actions';
// Models
import { INTEGRATIONS } from '../../model/global-configuration.constant';

@Injectable({
	providedIn: 'root'
})
export class DeliveryAssetsLoaderService implements CanActivate {
	constructor(private store: Store) {
	}

	/**
	 * Load all util lists for lender routes.
	 * @param childRoute
	 * @param state
	 */
	canActivate(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
		// eslint-disable-next-line no-async-promise-executor
		return new Promise(async resolve => {
			await this.store.dispatch(new SetTrackingSystems()).toPromise();
			await this.store.dispatch(new SetHandleMode()).toPromise();

			await this.store.dispatch(new SetProductListByIntegration(INTEGRATIONS.ACUITY)).toPromise();
			await this.store.dispatch(new SetProductListByIntegration(INTEGRATIONS.APPSCOPE)).toPromise();
			await this.store.dispatch(new SetProductListByIntegration(INTEGRATIONS.CMP_ACUTIY)).toPromise();

			await this.store.dispatch(new SetDeliveryAssetsAcuityDocumentTypes()).toPromise();
			await this.store.dispatch(new SetDeliveryAssetsAppScopeDocumentTypes()).toPromise();
			await this.store.dispatch(new SetDeliveryAssetsClassValuationDocumentTypes()).toPromise();
			await this.store.dispatch(new SetDeliveryAssetsCmpAcuityDocumentTypes()).toPromise();
			return resolve(true);
		});
	}
}
